import _axios from '@/utils/request'

// 注册管理-查询注册用户
export function postPageAccount(param) {
    return _axios('post', `/ms-shulan-hospital/v1/account/pageAccount`, param)
}

export function postPageAccountWithApply(param) {
    return _axios('post', `/ms-shulan-hospital/v1/account/pageAccountWithApply`, param)
}

// 注册管理-待认证-删除注册用户
export function deleteAccount(iuid) {
    return _axios('delete', `/ms-shulan-hospital/v1/account/${iuid}`, {}, 'specialurl')
}

// 注册管理-通过用户iuid获取认证单详情
export function getByAccountId(iuid) {
    return _axios('get', `/ms-shulan-hospital/v1/doctorApply/byAccountId/${iuid}`)
}
